//TODO: inconsistency in between kebab-case and camelCase in enum values

export enum AnalyticsEvent {
  ImpressionElement = 'impression-element',
}

export enum ContentPlacement {
  // Navigation
  Header = 'header',
  TopicNavigation = 'topicNavigation',
  AccountDropdown = 'myAccountDropdown',
  MyAccountLink = 'myAccountLink',

  DrawerMenu = 'drawer-menu',
  MenuMobile = 'menu-mobile',
  MyProfileLink = 'my-account-my-profile-navlink',

  // Footer
  Footer = 'footer-navigation',
  FooterSection = 'footer-navigation-link-wrapper',
  FooterSectionTitle = 'footer-navigation-section-title',
  FooterLink = 'footer-navigation-link',

  // Submenu
  MenuItem = 'itemLink',
  SubmenuItem = 'subMenuLevel',

  // Buttons
  BurgerButton = 'burger-button',
  CloseButton = 'closeButton',
  ArrowButton = 'arrow-button',
  LogoutButton = 'logoutBtnDesktop',
  UserIconButton = 'userIconButton',
  SignOutButton = 'logoutBtnDesktop',
  SearchButton = 'search-button',
  SubscribeButton = 'subscribeBtnDesktop',
  SigninButtonDesktop = 'signinBtnDesktop',
  SigninButtonMobile = 'signinBtnMobile',

  // Logo
  Logo = 'logo',
  FortuneLogo = 'fortune-logo',

  // Image
  FeatureHeaderF500Svg = 'feature-header-f500-svg',
  FeaturedImage = 'featured-image',
  PrimaryImage = 'primary_image',
  ImageCaption = 'caption',
  ImageCredit = 'credit',
  Image = 'image',
  ImageWrapper = 'image-wrapper',

  // Icons
  FacebookIcon = 'facebook-icon',
  TwitterIcon = 'x-icon',
  LinkedinIcon = 'linkedin-icon',
  InstagramIcon = 'instagram-icon',
  EmailIcon = 'email-icon',
  ShareIcon = 'share-icon',
  NativeShareIcon = 'native-share-icon',

  // Author
  AuthorItem = 'author-item',
  AuthorByText = 'author-by-text',
  AuthorName = 'author-name',
  AuthorByline = 'authorByLine',
  ReviewedByText = 'reviewed-by-text',
  PublishDate = 'feature-byline-publish-date',
  ReadTime = 'read-time',
  AuthorRole = 'author-role',
  AuthorsBioCards = 'authors-bio-cards',
  AuthorsBioSectionTitle = 'authors-bio-section-title',
  AuthorBio = 'author-bio',
  AuthorLink = 'author-link',
  AuthorSeeFullBio = 'author-see-full-bio',
  AuthorShortIntro = 'author-short-intro',
  AuthorImage = 'author-image',

  // Breadcrumbs
  Breadcrumbs = 'bread-crumbs',
  MobileBreadcrumbs = 'tablet-and-mobile-breadcrumbs',
  DesktopBreadcrumbs = 'desktop-breadcrumbs',

  // Article and Hero
  ArticleHero = 'article-container-eyebrow',
  ArticleWrapper = 'article-wrapper',
  ArticleContent = 'article-content',
  ArticleAuthorAndDate = 'article-author-and-date',
  ArticleTitle = 'article-title',
  ArticleAuthors = 'article-authors',
  ArticleEyebrow = 'article-eyebrow',
  ArticleSectionEyebrow = 'article-section-eyebrow',
  ArticleTagEyebrow = 'article-tag-eyebrow',
  SubscriptionPlea = 'subscriptionPlea',
  ArticleGeoTag = 'article-geo-tag',

  // Right Rail
  ArticleRightRail = 'article-right-rail',
  RightRailNavigation = 'rightRailNavigation',
  EducationArticleRail = 'education-article-rail',

  // Article Card
  ArticleCardWrapper = 'article-card-wrapper',
  ArticleCardImage = 'article-card-image',
  ArticleImageLink = 'article-image-link',
  CardWrapper = 'card-wrapper',
  ArticleCardTitle = 'article-card-title',
  ArticleCardByline = 'article-card-by-line',
  BylineAuthor = 'by-line-author',
  ArticleCardDate = 'article-card-date',
  ArticleCardExcerpt = 'article-card-excerpt',
  ArticleImage = 'article-image',
  PostList = 'post-list',
  TimeAgo = 'time-ago-wrapper',

  // Article Sections
  /* Top Articles */
  TopArticles = 'top-articles',
  TopArticlesTitle = 'top-articles-title',
  TopArticlesArticleList = 'top-articles-article-list',

  // Education specific
  /* Widgets */
  EducationArticleInstreamAd = 'edu_article_instream_ad',
  EducationCard = 'edu-card',
  EducationCardBanner = 'edu-card-banner',
  EducationCardContainer = 'edu-card-container',
  EducationCardContent = 'edu-card-content',
  EducationCardTitle = 'edu-card-title',
  EducationCardTitleHeading = 'edu-card-title-heading',
  EducationCardTitleSubheading = 'edu-card-title-subheading',
  EducationCardContentDescription = 'edu-card-content-description',
  EducationCardAction = 'edu-card-action',
  EducationCardPicture = 'edu-card-picture',
  EducationCardActionCta = 'edu-card-action-cta',

  // EzNewswire
  EzNewswirePressReleasesList = 'ez-newswire-press-releases-list',
  EzNewswireListPagination = 'ez-newswire-list-pagination',
  EzNewswireDisclaimerLink = 'ez-newswire-disclaimer-link',
  EzNewswirePressReleaseListInlineCta = 'ez-newswire-press-release-list-inline-cta',
  EzNewswireRightRail = 'ez-newswire-right-rail',
  EzNewswireRightRailCta = 'ez-newswire-right-rail-cta',
  EzNewswireRightRailCtaButton = 'ez-newswire-right-rail-cta-button',
  EzNewswirePressReleaseListInlineCtaButton = 'ez-newswire-press-release-list-inline-cta-button',
  EzNewswireListHeader = 'ez-newswire-list-header',
  EzNewswireListHeadlineLink = 'ez-newswire-list-headline-link',

  /* Ads */
  InStream = 'in-stream',
  InContent = 'in-content',
  NativoTout = 'nativoTout',
  RightRailFlex = 'right-rail-flex',
  RightRailArticleSticky = 'right-rail-article-sticky',
  StickyFooter = 'sticky-footer',

  /* Misc */
  DisclosureStripe = 'disclosure-stripe',

  // Misc
  OneTrustScript = 'one-trust-script',
  OneTrustUser = 'one-trust-user',
}
